import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

@Pipe({
  name: "formatTimeFromBackend",
})
export class FormatTimeFromBackendPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return this.formatTimeFromBackend(value);
  }

  formatTimeFromBackend(timeString: string) {
    const minutes = parseInt(timeString, 10);
    const duration = moment.duration(minutes, "minutes");
    const formattedTime = moment.utc(duration.asMilliseconds()).format("HH:mm");
    return formattedTime;
  }
}
